module.exports = require('./lib/dist/SweetAlert.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap-sweetalert/index.js
// module id = 4PT0
// module chunks = 11